"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    shoppingCart: {
      actions: {
        addToCart: 'Pridať do košíku',
        buy: 'Koupit',
        order: 'Objednat',
        remove: 'Odstranit'
      },
      cart: {
        total: {
          label: 'Celkem',
          helperText: '',
          helperTextPreview: ''
        },
        totalItems: {
          label: 'Celkem za řádky',
          helperText: '',
          helperTextPreview: ''
        },
        totalShipping: {
          label: 'Celkem za dopravu',
          helperText: '',
          helperTextPreview: ''
        },
        totalPayment: {
          label: 'Celkem za platbu',
          helperText: '',
          helperTextPreview: ''
        },
        totalTaxes: {
          label: 'Daně celkem',
          helperText: '',
          helperTextPreview: ''
        },
        resetCart: 'Resetovat košík'
      },
      messages: {
        confirmResetCart: 'Jste si jisti, že chcete smazat obsah košíku?',
        giftClaim: 'Můžete získat {quantity} kusů {productName} jako dárek.',
        cartManipulations: {
          allRemoved: 'Všechny položky košíku byly odstraneny.',
          itemAdded: 'Do košíku {number, plural, one {byla pridaná položka} other {byly pridany položky}}.',
          itemRemoved: 'Z košíku {number, plural, one {byla odstraněna položka} other {byly odstraněny položky}}.',
          quantityChaged: 'Změnilo se zakoupené množství.'
        }
      },
      components: {
        appBartActionCart: 'Košík',
        quantityField: {
          states: {
            quantityRounded: 'Množství bylo zaokrouhleno na nebližší velikost balení.'
          }
        },
        cartAsidePreview: {
          cartEmpty: 'Váš košík je prázdný'
        },
        cartAfterAddModal: {
          continueShopping: 'Pokračovat v nákupu',
          goToCart: 'Přejít do košíku',
          title: 'Produkty přidány do košíku',
          pcs: 'ks'
        }
      }
    }
  }
};
var _default = messages;
exports.default = _default;